App.factory('RecordService', RecordService);

function RecordService(Api) {
    return new RecordsClient.RecordService(Api.url2 + '/v2');
}